/** Stable IDs seeded by database/migrations/016_tenant_setup.sql. */
export const CUSTOMER_DEMO_TENANT_ID = 'cccccccc-cccc-cccc-cccc-cccccccccccc';
